//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ContourRefinement",1,0],[0,"ContourShift",1,0],[0,"CurvatureSectionPlane",1,"Plane",0],[0,"CurvatureType",1,0],[0,"DisplayType",1,0],[0,"MapCenter",1,0],[0,"MapRange",1,0],[0,"NormalOption",1,0],[0,"NormalOrientation",1,0],[0,"NormalOrigin",1,0],[0,"NormalVector",1,"Direction",0],[0,"NumberOfContours",1,0],[1,"Resolution",0,"GeometricUtilities.DisplayResolutionBuilder",0],[1,"ReverseIndividual",0,"SelectDisplayableObject",0],[0,"ScaleType",1,0],[0,"SectionOption",1,0],[0,"SectionOrientation",1,0],[0,"SectionOrigin",1,0],[1,"SelectObject",0,"SelectDisplayableObjectList",0],[0,"ShowZeroContour",1,0]],[[[],"ReverseAllNormals",{},0,0],[["face"],"ReverseIndividualNormal",{},1,0],[[],"UpdateReverseMap",{},0,0],[["faces"],"DeselectFaces",{},1,0]],[]];
SPLM.GeometricAnalysis.FaceCurvatureAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.FaceCurvatureAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.FaceCurvatureAnalysisBuilder.CurvatureTypes = Object.freeze({
    "Gaussian" : "Gaussian", "Absolute" : "Absolute", "Minimum" : "Minimum", "Maximum" : "Maximum", "Mean" : "Mean", "Normal" : "Normal", "Sectional" : "Sectional", "U" : "U", "V" : "V", "Radius" : "Radius"});

SPLM.GeometricAnalysis.FaceCurvatureAnalysisBuilder.DisplayTypes = Object.freeze({
    "Colormap" : "Colormap", "Contours" : "Contours", "ColormapAndContours" : "ColormapAndContours"});

SPLM.GeometricAnalysis.FaceCurvatureAnalysisBuilder.ScaleTypes = Object.freeze({
    "Linear" : "Linear", "Log" : "Log", "Area" : "Area"});

SPLM.GeometricAnalysis.FaceCurvatureAnalysisBuilder.DirectionTypes = Object.freeze({
    "Primitive" : "Primitive", "Manipulator" : "Manipulator"});

export default SPLM;